export { MockDialog } from './mock-dialog';
export { MockMatDialogRef } from './mock-mat-dialog-ref';
